module.exports = __webpack_public_path__ + "static/services_skincare.22299a5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pageheaders/services_skincare.jpg
// module id = 611
// module chunks = 244031977926288